<template>
    <div class="w-full mb-4">
        <div
            class="text-lg text-primary font-semibold mb-3 whitespace-pre-wrap"
        >
            {{ category.name }}
        </div>
        <document
            :media="doc"
            v-for="(doc, index) in category.documents"
            :key="index"
            @open-media="openMedia(doc)"
        />
    </div>
</template>

<script>
import { defineComponent, reactive } from "@vue/runtime-core";
import Document from "./Document.vue";

export default defineComponent({
    name: "DocumentsContainer",
    components: { Document },
    emits: ["openMedia"],
    props: { category: { required: true } },
    setup(_1, ctx) {
        const state = reactive({});

        function openMedia(media) {
            ctx.emit("openMedia", media);
        }

        return { state, openMedia };
    },
});
</script>
